/**
 * Created by Christof Sander on 27.09.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'trees'
	],

	config: {
		isBulkMode: false,
		showLayoutsOnly: false,
		isContainerSelector: false,
		treeTypeComponents: {
			default: [
				'/',
				'templates',
				'layoutTrees',
				'layoutTree'
			]
		},
		nodeActionMapping: {
			defaultContext: {
				lang: 'route',
				home: 'route',
				page: 'route'
			},
			defaultBaseActions: {
				select: {
					lang: 'showEdit_route',
					home: 'edit_routeContent',
					page: 'edit_routeContent'
				},
				deselect: {
					lang: 'showEdit_route',
					home: 'edit_routeContent',
					page: 'edit_routeContent'
				}
			}
		}
	},

	methods: {
		// operations
		showInsert: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, data) {
			var insertBefore    = buttonMode === 'before';
			var insertWithin    = buttonMode === 'within';
			var insertAfter     = buttonMode === 'after';
			var rootEntry       = buttonMode === 'root';
			var insertBulkRoot  = buttonMode === 'bulkRoot';
			var nodeData        = this.getSelectedNodeData();

			if(this.actions[baseActionKey]){
				if(buttonContext === 'layout'){
					var sort;
					var parentSectionID;
					var parentTemplateID;

					if(rootEntry){
						parentSectionID = 0;
						parentTemplateID = 0;
					}
					else {
						if(insertBefore){
							sort                = nodeData.sort;
							parentSectionID     = nodeData.parentSectionID;
							parentTemplateID    = nodeData.parentTemplateID;
						}
						else if(insertAfter){
							sort                = nodeData.sort + 1;
							parentSectionID     = nodeData.parentSectionID;
							parentTemplateID    = nodeData.parentTemplateID;
						}
						else if(insertWithin){
							parentTemplateID    = nodeData._primaryKey || nodeData.id;
						}
						else {
							// TODO: throw error
							console.error('invalid position found for new entry');
						}
					}

					return this.performAction(
						this.prepareAction(baseActionKey, undefined, undefined, {
							source: {
								load: {
									componentData: {
										config: {
											useCase: 'layout'
										},
										model: {
											dirtyFields: {
												data: {
													attributes: {
														parentTemplateID:   parentTemplateID,
														parentSectionID:    parentSectionID,
														sort:               sort,
														type:               (rootEntry || utils.isEmpty(parentSectionID) ? 'master' : 'layout')
													}
												}
											}
										}
									}
								}
							}
						})
					);
				}
				else if(buttonContext === 'section'){
					var templateID = nodeData.templateID;
					if(!templateID && nodeData.type === 'layout' && nodeData._primaryKey){
						templateID = nodeData._primaryKey;
					}

					var sort;
					if(nodeData.type === 'section' && nodeData.sort) {
						if(insertBefore){
							sort = nodeData.sort;
						} else {
							sort = nodeData.sort + 1;
						}
					}

					if(templateID){
						return this.performAction(
							this.prepareAction(baseActionKey, undefined, undefined, {
								source: {
									load: {
										componentData: {
											model: {
												dirtyFields: {
													data: {
														attributes: {
															templateID,
															sort
														}
													}
												}
											}
										}
									}
								}
							})
						);
					}
				}
				else if(buttonContext === 'component'){
					this.model.insertBefore     = insertBefore;
					this.model.insertAfter      = insertAfter;
					this.model.insertWithin     = insertWithin;
					this.model.insertBulkRoot   = insertBulkRoot;
					var resourceRegister = {
						componentTrees: {}
					};

					if(insertBulkRoot) {
						this.model.workflowSource = 'bulkRoot';
					} else if(nodeData.type === 'component'){
						this.model.workflowSource = 'component';
						var parentComponentID;

						if(insertWithin){
							parentComponentID = nodeData.componentID;
						}
						else if(nodeData.parentComponentID) {
							parentComponentID = nodeData.parentComponentID;
						}
						resourceRegister.componentTrees = {
							parentComponentID: parentComponentID
						};
					}
					else if(nodeData.type === 'section' && nodeData.parentType === 'component') {
						this.model.workflowSource = 'sectionComponent';
					}

					return this.performAction(
						this.prepareAction(baseActionKey, undefined, resourceRegister)
					);
				}
				else if(buttonContext === 'sectionComponent'){
					return this.performAction(
						this.prepareAction(baseActionKey, undefined, {
							nodeData: data.componentData
						})
					);
				}
			}

			return utils.promise.reject();
		},
		showMove: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, data) {
			if(buttonContext === 'sectionComponent'){
				const moveSectionComponent = this.getSelectedNodeData()
				if(moveSectionComponent){
					this.model.moveSectionComponent = moveSectionComponent;

					return this.performAction(
						this.prepareAction(baseActionKey)
					)
				}
			}
		},

		/**
		 * this function may be overwritten to manipulate the treeActionOptions.
		 *
		 * @param 	refOptions		object - all options needed to perform the right action on a jstree event. (see this.performTreeAction() for details)
		 */
		sanitizeTreeActionOptions: function(refOptions){
			refOptions = refOptions || {}
			const nodeData = refOptions.nodeData || {}
			const isChooseTargetComponent = this.hasClass('templates_bulk_chooseLayoutTrees')

			if(refOptions.baseActionOperation === 'showEdit'){
				if(refOptions.baseActionKey === 'showEdit_section'){
					if(nodeData.isBulkList) {
						if(refOptions.rightClickInCharge && this.hasRoleOption('bulkSectionAdministrator', 'layout')){
							// show section properties of bulk section component
						} else if(isChooseTargetComponent && !this.config.isContainerSelector){
							refOptions.baseActionKey = 'showMove_sectionComponent'
							refOptions.additionalResourceRegister.bulkContentBaseFilters = {
								sectionID: 						nodeData.sectionID,
								parentSectionComponentID: 		nodeData.parentSectionComponentID,
							}
							refOptions.additionalResourceRegister.bulkLayoutFilters = {
								sectionID: 						nodeData.sectionID,
								rootParentSectionComponentID: 	nodeData.parentSectionComponentID,
							}
						} else {
							refOptions.baseActionKey = 'showEdit_section_bulkContainer'
							refOptions.additionalResourceRegister.bulkContentBaseFilters = {
								sectionID: nodeData.sectionID,
								parentSectionComponentID: nodeData.parentSectionComponentID,
							}

							// clear old properties components even if no section properties may be shown to replace the previous ones.
							this.$.find('section.properties > *').each(function(){
								if((childComponent = getComponent(this))){
									childComponent.clear()
								}
							})
						}
					} else if(isChooseTargetComponent) {
						// move to end of section
						this.triggerClosest('onDecision', {
							decisionType: 'moveTargetSelected',
							decisionComponent: this,
							targetData: {
								type: 'moveToEnd',
								sectionID: nodeData.sectionID,
								parentSectionComponentID: nodeData.parentSectionComponentID
							}
						})
						this.closest('base_modal_modal', async modal => {
							await modal.hide();
						});
					} else if(nodeData.parentType !== 'layout') {
						var childComponent;
						refOptions.baseActionKey = 'showEdit_section_in_component'; // use non-existing base action key to prevent showEdit on sections which must not be edited within this view.

						// clear old properties components even if no section properties may be shown to replace the previous ones.
						this.$.find('section.properties > *').each(function(){
							if((childComponent = getComponent(this))){
								childComponent.clear()
							}
						})

						refOptions.storeAction = false
						refOptions.clearActionComponent = true
					}
				} else if(isChooseTargetComponent && !(this.model.states || {}).autoSelect){
					if(nodeData.type === 'component'){
						if(nodeData.subType === 'layout'){
							// show invalid operation message
							return this.performAction(
								this.prepareAction('message', undefined, {
									messageDisplay: {
										message: 'error:showMove.sectionComponent.toLayout'
									}
								})
							);
						} else {
							this.triggerClosest('onDecision', {
								decisionType: 'moveTargetSelected',
								decisionComponent: this,
								targetData: {
									type: 'moveToAfter',
									sectionComponentID: 		nodeData.sectionComponentID,
									sort: 						nodeData.sort,
									parentSectionComponentID: 	nodeData.parentSectionComponentID
								}
							})
							this.closest('base_modal_modal', async modal => {
								await modal.hide();
							});
						}
					} else {
						console.error('invalid chooseLayout action')
					}
				}
			}
		},

		/**
		 * show duplicate of sectionComponent.
		 *
		 * @param baseActionKey
		 * @param buttonContext
		 * @param buttonMode
		 * @param actionBossComponent
		 * @return {*}
		 */
		showDuplicate: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var self        = this;
			var nodeData    = self.getSelectedNodeData();
			var actionKey 	= baseActionKey + '_inEffect';

			if(self.actions[baseActionKey] && nodeData._primaryKey){
				self.model.selectedComponentID = nodeData.componentID
				self.model.workflowSource = 'component'
				self.model.insertAfter = true

				return self.performAndStoreAction(
					actionKey,
					self.prepareAction(baseActionKey, nodeData._primaryKey, { nodeData }),
					true
				);
			}

			return utils.promise.reject();
		},

		duplicate: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var self        = this;
			var nodeData    = this.getSelectedNodeData();
			var dirtyData   = {};
			if(nodeData.sort !== undefined){
				dirtyData = {
					data: {
						attributes: {
							sort: nodeData.sort + 1,
						}
					}
				};
			}

			if(this.actions[baseActionKey] && nodeData._primaryKey){

				return this.performAction(
					this.prepareAction(baseActionKey, nodeData._primaryKey, undefined, {
						source: {
							submit: {
								data: dirtyData
							}
						}
					})
				).then(function(context){

					if(self.config.isBulkMode && !nodeData.parentID){
						self.triggerClosest('showEdit', { id: context.response.data.attributes[context.response.data.primaryKey], refreshData: true })
					} else {
						// refresh trees
						self.config.readyNodeID         = context.response.data.attributes[context.response.data.primaryKey];
						self.config.readyNodeContext    = buttonContext;
						self.refreshTrees();
					}

					return utils.promise.resolve(context);
				});
			}

			return utils.promise.reject();
		},

		showProtocol: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			baseActionKey 		= 'showProtocol'
			const actionKey		= baseActionKey + '_inEffect';
			const nodeData    	= this.getSelectedNodeData();
			const entityID 		= nodeData._primaryKey
			const entityType 	= buttonContext
			const entityContext	= 'layout'

			if(entityID){
				return this.performAndStoreAction(
					actionKey,
					this.prepareAction(baseActionKey, undefined, {
						protocol: {
							entityID,
							entityType,
							entityContext
						}
					}),
					true
				);
			}

			return utils.promise.reject();
		},

		delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var self = this;

			return self.performDecision(
				'confirm',
				{
					component:  self,
					title:      storage.__('hint.delete.really.' + buttonContext + '.title'),
					message:    storage.__('hint.delete.really.' + buttonContext + '.message')
				}
			).then(function(context) {
				if (context.decision.type === 'yes' && self.actions[baseActionKey]){
					var nodeIndex = self.getSelectedNodeIndex();
					var nodeData = self.getSelectedNodeData();
					self.deselectActiveNode();
					let deleteAction = utils.promise.resolve();

					self.setClosestNodeAsReady(nodeIndex);

					if(buttonContext === 'layout') {
						if(nodeData.templateID != undefined && nodeData.type === 'component' && nodeData.subType === 'layout'){
							deleteAction = self.performAction(self.prepareAction(baseActionKey, nodeData.templateID));
						}
					}
					else if(buttonContext === 'section') {
						if(nodeData.sectionID != undefined && nodeData.type === 'section'){
							deleteAction = self.performAction(self.prepareAction(baseActionKey, nodeData.sectionID));
						}
					}
					else if(buttonContext === 'component'){
						if(nodeData.sectionComponentID != undefined){
							deleteAction = self.performAction(self.prepareAction(baseActionKey, nodeData.sectionComponentID))
						}
					}

					deleteAction.then(function(context){
						// reset tree only if root node has been deleted
						if(self.config.isBulkMode && !nodeData.parentID) {
							self.resetTree()
							self.triggerClosest('onDelete')
						} else {
							self.refreshTrees();
						}
						return context;
					})
				}

				return utils.promise.reject();
			});
		},

		resetTree: function(){
			this.deselectActiveNode()
			this.resourceData = {}
			delete this.config.readyNodeID
			this.config.readyNodeContext = ''
			delete this.model.states.activeTreeComponentIndex
			this.refresh(false)
		},

		sanitizeResources(storage){
			var self = this;
			var resources = {
				initialized: false,
				trees: [
					{
						name: 'Layouts...',
						tree: [],
						nodes: {}
					}
				]
			};

			if(!utils.isEmpty(this.resourceData) && !this.resourceData.initialized) {
				this.resetNodeMappings();
				this.config.extendedTreeView = this.hasRoleOption('extendedTreeView');

				var treeEntryIndex = 0;
				this.preSanitizeResourceChildren(this.resourceData, treeEntryIndex);

				resources.initialized = true;
				var children = this.sanitizeResourceChildren(storage, this.resourceData);
				resources.trees[0].tree = children.tree;
				resources.trees[0].nodes = children.nodes;

				this.resourceData = resources;
			}
		},

		preSanitizeResourceChildren: function(resources, treeEntryIndex, parentType, parentID){
			var self = this;
			var primaryKey;
			var treeEntryIDPostfix;
			var context;
			for(var resourceIndex in resources){
				treeEntryIDPostfix = undefined;

				if(resources[resourceIndex].type === 'section'){
					primaryKey = 'sectionID';
					context = 'section';

					if(parentType === 'component'){
						treeEntryIDPostfix = parentID;
					} else {
						resources[resourceIndex].parentType = 'layout'
					}
				}
				else if(resources[resourceIndex].type === 'component'){
					primaryKey = 'sectionComponentID';
					context = 'component';
					if(resources[resourceIndex].subType === 'layout'){
						primaryKey = 'templateID';
						context = 'layout';
					}
				}

				resources[resourceIndex].index = self.transformIDToIndex(resources[resourceIndex][primaryKey] + (treeEntryIDPostfix ? '_' + treeEntryIDPostfix : ''), context, 0, treeEntryIndex);
				treeEntryIndex++;

				if(!utils.isEmpty(resources[resourceIndex].children)){
					treeEntryIndex = self.preSanitizeResourceChildren(resources[resourceIndex].children, treeEntryIndex, context, resources[resourceIndex][primaryKey]);
				}
			}

			return treeEntryIndex;
		},

		sanitizeResourceChildren: function(storage, resources, parentIndex, parentID, parentType, lastSectionID){
			// init
			var self = this;
			var tree = [];
			var nodes = {};
			var primaryKey;
			var context, contextIcon;
			// var parent;
			// var parentKey;
			var treeEntryIDPostfix;
			var text, langDependentName;
			var nextParentType;
			var extraNodeData = {};
			var additionalClasses = '';
			parentIndex = parentIndex || '#';

			utils.forEach(resources, function(resource){
				primaryKey          = 'templateID';
				context             = 'layout';
				contextIcon         = undefined;
				treeEntryIDPostfix  = undefined;
				text = 'not defined...';
				langDependentName = '';
				extraNodeData = {
					parentType: parentType,
					parentID:   parentID
				};
				nextParentType = undefined;

				switch(resource.type){
					case 'section':
						primaryKey = 'sectionID';
						context = 'section';
						nextParentType = 'section';
						text = resource.code;
						if(parentType === 'component'){
							extraNodeData.componentID = parentID;
							extraNodeData.parentSectionComponentID = parentID;
							treeEntryIDPostfix = parentID;
						}
						else if(parentType === 'layout'){
							extraNodeData.templateID = parentID;
						}

						if(resource.isBulkList){
							contextIcon = 'fi fi-section-bulk'
						}

						lastSectionID = resource[primaryKey];
						break;

					case 'component':
						text = resource.component.join('/');

						switch(resource.subType){
							case 'form':
							case 'default':
								// primaryKey = 'componentInstanceID';
								primaryKey = 'sectionComponentID';
								context = 'component';
								nextParentType = 'component';

								if(resource.config && resource.config.isShadowComponent){
									contextIcon = 'fi fi-component';
								}
								else if(resource.subType === 'form'){
									contextIcon = 'fi fi-form';
								}

								if(!utils.isEmpty(resource.parentSectionComponentID)){
									// NOTE:    sectionIDs are not unique!
									//          therefor components located within sections of sectionComponents has to be positioned
									//          within sections identified by a combined key
									//          which consists of the sectionID and the parentSectionComponentID.
									if(!resource.sectionID || parentType === 'component'){
										parentIndex = self.getNodeIndex(resource.parentSectionComponentID, 'component');
									}
									else {
										parentIndex = self.getNodeIndex(resource.sectionID + '_' + resource.parentSectionComponentID, 'section');
									}

									if(!parentIndex) parentIndex = self.getNodeIndex(lastSectionID, 'section');
								}
								else if(lastSectionID) {
									parentIndex = self.getNodeIndex(lastSectionID, 'section');
								}
								break;

							case 'layout':
								nextParentType = 'layout';
								if(self.config.showLayoutsOnly || (resource.parentTemplateID && !resource.parentSectionID)){
									if(!utils.isEmpty(resource.parentTemplateID)){
										parentIndex = self.getNodeIndex(resource.parentTemplateID, 'layout');
									}
									else {
										parentIndex = '#';
									}
								}
								else if(!utils.isEmpty(resource.parentSectionID)){
									parentIndex = self.getNodeIndex(resource.parentSectionID, 'section');
								}
								else {
									parentIndex = '#';
								}
								break;
						}
						break;
				}

				// estimate lang dependent text if possible
				if(resource.lang && resource.lang[storage.langCode] && resource.lang[storage.langCode].name){
					langDependentName = resource.lang[storage.langCode].name;
				}
				if(resource.componentName){
					text = langDependentName + ' - ' + resource.componentName;
				}
				else {
					text = langDependentName;
				}

				if(utils.isEmpty(resource[primaryKey])){
					// TODO: throw error
					console.log(parentIndex, primaryKey, resource);
					console.error('primaryKey not found @ ' + primaryKey);
				}
				else if(!self.config.showLayoutsOnly || resource.subType === 'layout'){
					if(self.config.extendedTreeView) text += ` [#${resource[primaryKey]} - ${resource.sort || 0}]`;

					additionalClasses = '';
					if(resource.status && resource.status === 'preview'){
						additionalClasses = 'state_preview';
					}
					else if(resource.status && resource.status === 'inactive'){
						additionalClasses = 'state_inactive';
					}

					tree.push({
						id: resource.index,
						parent: parentIndex || '#',
						text: text,
						icon: contextIcon,
						type: context,
						state: {
							opened: true,
							disabled: false,
							selected: false
						},
						li_attr: {},
						a_attr: {
							class: additionalClasses
						}
					});
					nodes[resource.index] = utils.replace(resource, { children: undefined }, extraNodeData, { _primaryKey: resource[primaryKey] });

					// prepare children
					if(!utils.isEmpty(resource.children)){
						var children = self.sanitizeResourceChildren(storage, resource.children, resource.index, resource[primaryKey], nextParentType, lastSectionID);
						tree = tree.concat(children.tree);
						nodes = utils.replace(nodes, children.nodes);
					}
				}
			});

			return {
				tree: tree,
				nodes: nodes
			};
		},

		handleError: function(context){
			const baseError = utils.extractBaseError(context.error);

			if(baseError.statusCode == 404 && baseError.errorCode === 'REQUEST_HANDLER_POSTDATA_SECTION_COMPONENTS_VALIDATION_ERROR_1'){
				this.refreshTrees();
				return this.performAction(
					this.prepareAction('message', undefined, {
						messageDisplay: {
							message: 'error:layoutTree.sortMeta.targetNodeNotFound'
						}
					}, {
						rollbackContext: context,
						statusControllerLoadingMessage: '',
						statusControllerSavingMessage:  ''
					})
				);
			}

			context.errorUnhandled = true;
			return utils.promise.resolve(context);
		},

		// TODO: DOC!
		onTreeAction: function (data) {
			var self = this;
			// TODO: CLEANUP
			// console.log('layoutTrees - onTreeAction', data, this.model.states);
			var actionFormsSelector = '.base_treesManagement_actionsForm';

			switch (data.onTreeActionOptions.eventType) {
				case 'move_node.jstree':
					var moveEntry = data.onTreeActionOptions.eventData.node;
					var moveEntryContext = this.getNodeContext(moveEntry.id);
					var actionKey = data.onTreeActionOptions.operation  + '_' + moveEntryContext;
					if(this.actions[actionKey]){
						var moveNode = this.getNodeData(moveEntry.id);
						var newInParentPosition = data.onTreeActionOptions.eventData.position;
						var newParentEntry, newParentNode;
						var movementAttributes;
						if(moveEntry.parent && moveEntry.parent != '#'){
							newParentEntry = this.getNode(moveEntry.parent);
							newParentNode = this.getNodeData(moveEntry.parent);
						}

						if(moveEntryContext === 'layout'){
							movementAttributes = {
								parentTemplateID:   0,
								parentSectionID:    0
							};

							if(newParentNode){
								if(newParentNode.subType === 'layout'){
									movementAttributes.parentTemplateID = newParentNode.templateID;
								}
								else if(newParentNode.type === 'section' && newParentNode.parentType === 'layout'){
									movementAttributes.parentTemplateID = newParentNode.templateID;
									movementAttributes.parentSectionID  = newParentNode.sectionID;
								}
							}
						}
						else if(moveEntryContext === 'section'){
							if(moveNode.parentType === 'layout' && newParentNode && newParentNode.subType === 'layout'){
								movementAttributes = {
									templateID: newParentNode.templateID,
									sort:       this.getNewSortFieldValue(
										moveEntryContext,
										moveEntry.parent,
										newInParentPosition,
										newParentNode.sort,
										function(nodeEntry, nodeData){
											return nodeEntry.id != moveEntry.id && nodeData.type === 'section';
										},
										data.onTreeActionOptions.treeComponentIndex
									)
								};
							}
						}
						else if(moveEntryContext === 'component'){

							if(
								// actual node is allowed to exist every where
								(
									moveNode.config
									&&
									moveNode.config.freeUsageAllowed
								)
								||
								(
									newParentNode
									&&
									(
										// new parent node allows all components to exist as direct child
										(
											newParentNode.config
											&&
											newParentNode.config.freeChildUsageAllowed
										)
										||
										// new parent node is a section
										(
											newParentNode.type === 'section'
										)
									)
								)
							){
								movementAttributes = {
									sectionID:                  null,
									parentSectionComponentID:   0,
									sort:                       undefined
								};

								if(newParentNode.type === 'component'){
									movementAttributes.parentSectionComponentID = newParentNode.sectionComponentID;
									movementAttributes.sort         			= this.getNewSortFieldValue(
										moveEntryContext,
										moveEntry.parent,
										newInParentPosition,
										newParentNode.sort,
										function(nodeEntry, nodeData){
											return nodeEntry.id != moveEntry.id && nodeData.sectionComponentID != undefined;
										},
										data.onTreeActionOptions.treeComponentIndex
									);
								}
								else if(newParentNode.parentType === 'layout' || newParentNode.parentType === 'component'){
									movementAttributes.sectionID    = newParentNode.sectionID;
									movementAttributes.sort         = this.getNewSortFieldValue(
										moveEntryContext,
										moveEntry.parent,
										newInParentPosition,
										newParentNode.sort,
										function(nodeEntry, nodeData){
											return nodeEntry.id != moveEntry.id && nodeData.sectionComponentID != undefined;
										},
										data.onTreeActionOptions.treeComponentIndex
									);

									if(newParentNode.parentType === 'component'){
										movementAttributes.parentSectionComponentID = newParentNode.parentID;
									}
								}
							}
						}

						if(movementAttributes){
							this.performAction(
								this.prepareAction(actionKey, moveNode._primaryKey, undefined, {
									source: {
										submit: {
											data: {
												data: {
													attributes: movementAttributes
												}
											}
										}
									}
								})
							).then(function(){
								// refresh to get the lists up to date after movement
								self.refreshTrees();
							}).fail(function(error){
								// prevent wrong gui state from being displayed
								self.refreshTrees();
							});
						}
						else {
							self.refreshTrees();
							throw new Error('NO MOVEMENT ATTRIBUTES FOUND: ' + actionKey + ', ' + moveEntryContext);
						}
					}
					else {
						self.refreshTrees();
						throw new Error('ACTION NOT FOUND: ' + actionKey);
					}
					break;

				case 'select_node.jstree':
					// TODO: impl. animation and animation-delay
					// show page actions if necessary
					this.$.find(actionFormsSelector).hide();
					var selector = '.layoutTreesActions';
					if(data.onTreeActionOptions.eventData.node.type === 'section'){
						if(data.onTreeActionOptions.nodeData.isBulkList && (!data.onTreeActionOptions.rightClickInCharge || !this.hasRoleOption('bulkSectionAdministrator', 'layout'))){
							selector = ''
						}
						else if(data.onTreeActionOptions.nodeData.parentType === 'component'){
							selector = '.layoutTreesComponentSectionActions';
						}
						else if(data.onTreeActionOptions.nodeData.parentType === 'layout'){
							selector = '.layoutTreesSectionActions';
						}
					}
					else if(data.onTreeActionOptions.eventData.node.type === 'component'){
						selector = '.layoutTreesComponentActions';
					}
					if(selector){
						this.$.find(selector).show();
					}
					break;

				case 'deselect_node.jstree':
					// hide page actions if necessary
					this.$.find(actionFormsSelector).hide();
					break;
			}
		}
	},

	hooks: {
		async onDecision($element, options){
			switch(options.decisionType){
				case 'moveTargetSelected':
					if(this.model.moveSectionComponent){
						const target = options.targetData || {};
						const source = this.model.moveSectionComponent || {};
						const actionKey = 'move_component'
						let movementAttributes = false

						if(!source.sectionComponentID){
							return console.error('not able to move sectionComponent', source);
						}

						// move in relation to component
						// note: sectionID may not be present
						if(target.sectionComponentID){
							movementAttributes = {}

							if(target.type === 'moveToAfter'){
								movementAttributes.sortMeta = {
									position: 'after',
									targetID: target.sectionComponentID,
									targetType: 'component',
									modelSortParentNotRequired: true
								}
							} else if(target.type === 'moveToBefore'){
								movementAttributes.sortMeta = {
									position: 'before',
									targetID: target.sectionComponentID,
									targetType: 'component',
									modelSortParentNotRequired: true
								}
							} else {
								// TODO: ev standard?
								console.error('move sectionComponent to sectionComponent: invalid target.type', target.type)
							}
						}
						// move in relation to section
						else if(target.sectionID){
							movementAttributes = {
								sectionID: target.sectionID,
								parentSectionComponentID: target.parentSectionComponentID || 0
							}

							if(target.type === 'moveToEnd'){
								movementAttributes.sortMeta = {
									position: 'childEnd',
									targetID: target.sectionID,
									targetType: 'section',
								}
							} else if(target.type === 'moveToStart'){
								movementAttributes.sortMeta = {
									position: 'childStart',
									targetID: target.sectionID,
									targetType: 'section',
								}
							} else {
								// TODO: ev standard?
								console.error('move sectionComponent to section: invalid target.type', target.type)
							}
						}
						else {
							console.error('invalid sectionComponent move to target', target)
						}

						if((movementAttributes || {}).sortMeta){
							let success = false
							try {
								await this.performAction(
									this.prepareAction(actionKey, source.sectionComponentID, undefined, {
										source: {
											submit: {
												data: {
													data: {
														attributes: movementAttributes
													}
												}
											}
										}
									})
								)
								success = true
							} catch (error){
								// prevent wrong gui state from being displayed
								let nodeWasMissing = false
								this.deselectActiveNode();
								this.locate('< templates_bulk_contentController > templates_bulk_contentTable', contentTable => {
									contentTable.refreshData(true)
									nodeWasMissing = contentTable.deselectActiveNodeIfMissing()
								})
								if(!nodeWasMissing){
									this.refreshTrees();
								}
							}

							if(success){
								// refresh to get the lists up to date after movement
								let nodeWasMissing = false
								this.deselectActiveNode();
								if(!source.parentID){
									this.locate('< templates_bulk_contentController > templates_bulk_contentTable', contentTable => {
										contentTable.refreshData(true, {
											onRefreshDoneCallback: () => {
												if(contentTable.getNrOfRows() < 1){
													this.triggerClosest('forceBySearchTerm', { searchTerm: '' }, 'templates_bulk_contentController')
												}
											}
										})
										nodeWasMissing = contentTable.deselectActiveNodeIfMissing()
									})
								}
								if(!nodeWasMissing){
									this.refreshTrees();
								}
								getComponent('statusController').addPanel('status.done.move')
							}
						}
						else {
							this.refreshTrees();
							throw new Error('NO MOVEMENT ATTRIBUTES FOUND: ' + actionKey + ', sectionComponent');
						}

						delete this.model.moveSectionComponent
					} else {
						// move proxy for final decision layoutTrees component within recursive layoutTrees structure of bulk layout trees
						await this.triggerClosest('onDecision', options)
						let modal
						this.closest('base_modal_modal', c => modal = c)
						if(modal){
							await modal.hide()
						}
					}
					break;

				case 'submit':
					switch(options.decisionComponent.componentClass) {
						case 'templates_componentTrees_selectComponentTrees':
							// get selected component id
							this.model.selectedComponentID = options.data._primaryKey || options.data.id

							// deselect selected component for next usage
							options.decisionComponent.deselectActiveNode()

							const context = await this.performAction(this.prepareAction('getComponentsModelFields', this.model.selectedComponentID))

							// show modal with new template atom properties form
							await this.showInsert('showInsert_sectionComponent', 'sectionComponent', undefined, this, { componentData: context.action.response })
							let modal
							options.decisionComponent.closest('base_modal_modal', c => modal = c)
							if(modal){
								await modal.hide()
							}
							break

						case 'base_modal_modal':
						case 'templates_modal_modal':
							var modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component;
							if(modalContentComponent){
								if(modalContentComponent.hasClass('templates_propertiesForms_componentContentForm') && this.model.selectedComponentID != undefined){
									var nodeData = this.getSelectedNodeData();
									var additionalComponentAttributes = {
										componentID: 	this.model.selectedComponentID,
										sectionID: 		nodeData.sectionID || (this.model.bulkContentBaseFilters || {}).sectionID,
									};

									if(this.model.workflowSource === 'bulkRoot'){
										if((this.model.bulkContentBaseFilters || {}).sectionID){
											additionalComponentAttributes.sectionID = this.model.bulkContentBaseFilters.sectionID;
											if(this.model.bulkContentBaseFilters.parentSectionComponentID){
												additionalComponentAttributes.parentSectionComponentID = this.model.bulkContentBaseFilters.parentSectionComponentID;
											}
										} else {
											console.error('no bulk root found!')
											delete additionalComponentAttributes.sectionID;
										}
									} else if(this.model.workflowSource === 'component'){
										if(this.model.insertBefore){
											additionalComponentAttributes.parentSectionComponentID = nodeData.parentSectionComponentID;
											additionalComponentAttributes.sortMeta = {
												position: 'before',
												targetID: nodeData.sectionComponentID,
												targetType: 'component',
												modelSortParentNotRequired: true
											}
										}
										else if(this.model.insertAfter){
											additionalComponentAttributes.parentSectionComponentID = nodeData.parentSectionComponentID;
											additionalComponentAttributes.sortMeta = {
												position: 'after',
												targetID: nodeData.sectionComponentID,
												targetType: 'component',
												modelSortParentNotRequired: true
											}
										}
										else if(this.model.insertWithin){
											additionalComponentAttributes.sectionID = null;
											additionalComponentAttributes.parentSectionComponentID = nodeData.sectionComponentID;
											additionalComponentAttributes.sortMeta = {
												position: 'child',
												targetID: nodeData.sectionComponentID,
												targetType: 'component',
												modelSortParentNotRequired: true
											}
										}
									}
									else if(this.model.workflowSource === 'sectionComponent'){
										additionalComponentAttributes.parentSectionComponentID = nodeData.parentID;
										additionalComponentAttributes.sortMeta = {
											targetType: 'section',
											targetID: nodeData.sectionID,
											position: 'childStart',
											modelSortParentNotRequired: true
										}
									}

									const insertAtRootLevel = this.model.insertBulkRoot || (!nodeData.parentID && (this.model.insertBefore || this.model.insertAfter));

									// cleanup
									delete this.model.insertBefore;
									delete this.model.insertAfter;
									delete this.model.insertWithin;
									delete this.model.insertBulkRoot;
									delete this.model.workflowSource;

									modalContentComponent.model.dirtyFields = utils.merge(modalContentComponent.model.dirtyFields, {
										data: {
											attributes: additionalComponentAttributes
										}
									});
									const context = await modalContentComponent.submit()
									delete this.model.selectedComponentID

									// reset form and hide forms' modal
									context.component.forEachSubForm(subForm => { subForm.model.dirtyFields = {}; });
									options.decisionComponent.destroy();

									if(this.config.isBulkMode && insertAtRootLevel){
										this.triggerClosest('showEdit', { id: context.response.data.attributes[context.response.data.primaryKey], refreshData: true })
									} else {
										// refresh trees
										this.config.readyNodeID       = context.response.data.attributes[context.response.data.primaryKey];
										this.config.readyNodeContext  = 'component';
										this.refreshTrees();
									}
								}
								else if (modalContentComponent.hasClass('templates_layoutTrees_chooseLayoutTrees')){
									// TODO: ???
									// console.log(options)
								}
							}
							break;
					}
					break;

				case 'cancel':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							this.deselectActiveNode()
							await options.decisionComponent.hide()
							delete this.model.selectedComponentID
							this.refreshTrees(true)
							break;

						case 'templates_componentTrees_selectComponentTrees':
							let modal
							options.decisionComponent.closest('base_modal_modal', c => modal = c)
							if(modal){
								await modal.hide()
							}
							break;
					}
					break;

				default:
				// TODO: ERROR;
			}
		}
	},

	handlers: [
		{
			name: 'afterCancel',
			componentClass: 'templates_propertiesForms_templatePropertiesForm',
			handle: function(callerComponent){
				this.deselectActiveNode();
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_templatePropertiesForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				if(insertPerformed){
					this.config.readyNodeID       = nodeData.data.attributes[nodeData.data.primaryKey] ;
					this.config.readyNodeContext  = 'layout';
					callerComponent.destroy();
				}
				this.refreshTrees();
			}
		},
		{
			name: 'afterCancel',
			componentClass: 'templates_propertiesForms_sectionPropertiesForm',
			handle: function(callerComponent){
				this.deselectActiveNode();
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_sectionPropertiesForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				if(insertPerformed){
					this.config.readyNodeID       = nodeData.data.attributes[nodeData.data.primaryKey] ;
					this.config.readyNodeContext  = 'section';
					callerComponent.destroy();
				}
				this.refreshTrees();
			}
		},
		{
			name: 'afterCancel',
			componentClass: 'templates_propertiesForms_componentContentForm',
			handle: function(callerComponent){
				const ci = this.componentIndex
				callerComponent.locate('< templates_layoutTrees_layoutTrees', function(layoutTrees){
					if(layoutTrees.componentIndex === ci){
						layoutTrees.deselectActiveNode();
					}
				});
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_componentContentForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				// in case of insert the modal decision is used to perform any necessary processes
				if(!insertPerformed){
					const ci = this.componentIndex
					callerComponent.locate('< templates_layoutTrees_layoutTrees', function(layoutTrees){
						if(layoutTrees.componentIndex === ci){
							// prevent selection of last selected element
							layoutTrees.config.readyNodeID = undefined;
							layoutTrees.refreshTrees();
						}
					});

					this.locate('< templates_bulk_contentController > templates_bulk_contentTable', function(contentTable){
						contentTable.refreshData(true)
					})
				}
			}
		}
	]
};
